import { render, staticRenderFns } from "./ForumThreadEditorThemes.vue?vue&type=template&id=332e7e40&scoped=true"
import script from "./ForumThreadEditorThemes.vue?vue&type=script&lang=js"
export * from "./ForumThreadEditorThemes.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadEditorThemes.vue?vue&type=style&index=0&id=332e7e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332e7e40",
  null
  
)

export default component.exports